import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { QueryKeys } from '../common/types';
import { client } from '../common/services';
import { GetMeDTO } from '@bandido/shared/dtos';

interface useGetMyUserDataProps {
  onErrorCallback?: (_e: AxiosError) => void;
}

export const useGetMyUserData = (props?: useGetMyUserDataProps) => {
  const { onErrorCallback } = props ?? {};
  return useQuery({
    queryKey: [QueryKeys.getMyUserData],
    queryFn: async () => {
      try {
        return await client.get<GetMeDTO>('user/me');
      } catch (_e) {
        onErrorCallback && onErrorCallback(_e as AxiosError);
      }
    },
    refetchOnWindowFocus: true,
  });
};

export const useGetMyUserAgencies = (props?: useGetMyUserDataProps) => {
  const { onErrorCallback } = props ?? {};
  return useQuery({
    queryKey: [QueryKeys.getMyUserAgencies],
    queryFn: async () => {
      try {
        return (await client.get<number[]>('user/me/agencies')).data;
      } catch (_e) {
        onErrorCallback && onErrorCallback(_e as AxiosError);
      }
    },
    refetchOnWindowFocus: true,
  });
};
